/**
 * Copy text, and say whether it really landed. `navigator.clipboard` is missing
 * on plain-http origins and rejects without focus or permission, so a copy
 * button that reports success without awaiting this tells people a secret was
 * saved when it was not.
 */
export async function copyText(text) {
  if (!navigator.clipboard?.writeText) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
